import "./NewsArticleTypes.scss";
import NewsArticleTypesList from "@/components/News/NewsArticleTypesList/NewsArticleTypesList.vue";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "NewsArticleTypes",
  components: { NewsArticleTypesList },

  data: () => ({
    dialog: false,
    headers: [
      { text: "Titel", value: "title" },
      { text: "Value", value: "value" },
      { text: "Kanäle", value: "channels" },
      { text: "Erstellt", value: "create_date" },
      { text: "Geändert", value: "change_date" },
      {
        text: "Aktionen",
        value: "actions",
        sortable: false,
        align: "center",
        width: "5%"
      }
    ],
    editedItem: {
      title: "",
      description: "",
      value: "",
      channels: []
    },
    defaultItem: {
      title: "",
      description: "",
      value: "",
      channels: []
    },
    editLoading: false
  }),
  async mounted() {
    if (!this.isAdmin && !this.isNewsAdmin) {
      return await this.$router.push(`/news/`);
    }
    await this.$store.dispatch("getNewsConfig");
    await this.loadArticleTypes();
  },
  computed: {
    formTitle() {
      return this.editedItem.isNew
        ? "Artikeltypen anlegen"
        : "Artikeltypen bearbeiten";
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    isNewsAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:news_admin");
    },
    isValid() {
      return (
        this.editedItem?.title?.length &&
        this.editedItem?.value?.length &&
        this.editedItem?.channels?.length
      );
    },
    standardChannels() {
      return this.$store.state.newsConfig.standard_channels ?? [];
    },
    channels() {
      const ownChannels = this.$store.state.newsConfig.own_channels ?? [];
      return this.standardChannels.concat(ownChannels);
    },
    selectableChannels() {
      return !this.editedItem?.owner ? this.standardChannels : this.channels;
    },
    articleTypes() {
      return this.$store.state.newsArticleTypes ?? [];
    },
    globalArticleTypes() {
      return this.articleTypes?.length ? this.getGlobalArticleTypes(null) : [];
    },
    subscribedArticleTypes: {
      get() {
        return this.getGlobalArticleTypes(true);
      },
      async set(newVal) {
        const oldVal = this.subscribedArticleTypes,
          changedValues = [],
          globalArticleTypes = this.getGlobalArticleTypes(null);

        if (newVal.length > oldVal.length)
          newVal.forEach(val => {
            if (!oldVal.find(ov => ov._id === val)) {
              const changedVal = globalArticleTypes?.find(
                articleType => articleType._id === val
              );
              changedVal.principals.push(this.currentPrincipal);
              changedValues.push(changedVal);
            }
          });
        else
          oldVal.forEach(val => {
            if (!newVal.find(nv => nv === val._id)) {
              val.principals.remove(this.currentPrincipal);
              changedValues.push(val);
            }
          });

        await changedValues.asyncForEach(async val => {
          await this.updateArticleType(val);
        });
      }
    },
    ownArticleTypes() {
      return this.articleTypes.filter(
        item => item.owner === this.currentPrincipal
      );
    }
  },
  methods: {
    async createError(error) {
      this.$store.dispatch("createError", error);
    },
    async createSuccess(successMessage) {
      this.$store.dispatch("createSuccess", successMessage);
    },
    async loadArticleTypes() {
      try {
        await this.$store.dispatch("getNewsArticleTypes", {
          principal_id: this.currentPrincipal,
          ignorePrincipalId: this.isAdmin ? 1 : 0
        });
      } catch (err) {
        this.$emit("createError", err);
      }
    },
    getGlobalArticleTypes(subscribed) {
      if (this.articleTypes && this.currentPrincipal) {
        const principalId =
          typeof this.currentPrincipal === "string"
            ? this.currentPrincipal
            : "xx";
        return this.articleTypes.filter(
          articleType =>
            !articleType.owner &&
            (subscribed === null
              ? true
              : subscribed
              ? (articleType.principals ?? []).includes(principalId)
              : !(articleType.principals ?? []).includes(principalId))
        );
      } else return [];
    },
    createItem(global = false) {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedItem.isNew = true;
      this.editedItem.principal_id = this.currentPrincipal;
      this.editedItem.owner = this.currentPrincipal;
      this.editedItem.principals = [this.currentPrincipal];
      if (global && this.isAdmin) {
        this.editedItem.owner = null;
      }
      this.dialog = true;
      this.$refs?.editForm?.reset();
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.editedItem.isNew = false;
      this.dialog = true;
    },
    async deleteItem(item) {
      const confirmed = await this.$confirm(
        `Sind Sie sicher, dass Sie 
        <br>"${item.title}" löschen wollen?`,
        confirmWarningConfig
      );
      if (confirmed) {
        try {
          await this.deleteArticleType(item);
        } catch (err) {
          this.createError(err);
          return;
        }
        this.editedItem = Object.assign({}, item);

        this.loadArticleTypes().then(this.closeDelete);
      }
    },
    async deleteArticleType(item) {
      const title = item.title;
      const params = {
        principal_id: this.currentPrincipal
      };
      const headers = getTokenHeader(),
        res = await axios.delete(
          `${env.news_api_client_url}article_type/${item._id}`,
          {
            headers,
            params
          }
        );
      if (res.status === 200) {
        this.createSuccess(title + " gelöscht!");
      } else {
        this.createError({ ...res, text: item.title + " nicht gelöscht!" });
      }
    },
    async afterSave(close) {
      await this.loadArticleTypes();
      if (close) {
        this.close();
      }
      this.createSuccess("Erfolgreich gespeichert!");
    },
    close() {
      this.editedItem = { ...this.defaultItem };
      this.dialog = false;

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
    closeDelete() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
    async save(close) {
      if (this.$refs.editForm.validate()) {
        let success = false;
        this.loadingStatus(true);
        try {
          success = this.editedItem.isNew
            ? await this.createArticleType()
            : await this.updateArticleType();
          if (success) {
            this.afterSave(close);
          }
        } catch (ex) {
          this.createError(ex);
        }
        this.loadingStatus(false);
      } else {
        this.createError({
          text: "Nicht gespeichert! Bitte alle Pflichtfelder überprüfen!"
        });
      }
    },
    getPayload() {
      const payload = { ...this.editedItem };
      delete payload.isNew;
      return payload;
    },
    async updateArticleType(item) {
      if (item?._id) this.editedItem = item;
      const headers = getTokenHeader(),
        res = await axios.put(
          `${env.news_api_client_url}article_type`,
          this.getPayload(),
          { headers }
        );
      return res.status === 200;
    },
    async createArticleType() {
      const headers = getTokenHeader(),
        res = await axios.post(
          `${env.news_api_client_url}article_type`,
          this.getPayload(),
          { headers }
        );
      this.editedItem.isNew = false;
      this.editedItem._id = res.data._id;
      return res.status === 200;
    },
    loadingStatus(status) {
      this.editLoading = status;
    }
  }
};
